import KLineCanvas from "@/components/KLineCanvas";

/**
 * 顶部 BTC 分时 K 线背景区块（数据来自 OKX 公共 tickers WSS，见 useKLineData）。
 *
 * 设计：
 * - 不再是 `fixed inset-0` 全屏背景，而是 `absolute top-0` 的"顶部条带"
 * - 由父级 `<main>`（relative）作为定位上下文，所以会随页面滚动一起上移
 * - 固定 `height` + `overflow-hidden` 形成上下边界，不会"穿"到下方智能体卡片
 * - z-0 + pointer-events-none，纯装饰，不抢交互
 */
interface KLineBackdropProps {
  /** 顶部 K 线条带高度（含 TopHeader 重叠区域，建议 240~360） */
  height?: number;
  /** Canvas 透明度 */
  opacity?: number;
}

export function KLineBackdrop({
  height = 140,
  opacity = 0.55,
}: KLineBackdropProps) {
  return (
    <div
      className="absolute top-[5.375rem] left-0 right-0 pointer-events-none z-0 overflow-hidden"
      style={{ height }}
      aria-hidden
    >
      <KLineCanvas height={height} opacity={opacity} />

      <svg
        className="absolute inset-0 w-full h-full"
        style={{ opacity: 0.025 }}
        aria-hidden
      >
        <defs>
          <pattern
            id="fort-kline-grid-dots"
            width={32}
            height={32}
            patternUnits="userSpaceOnUse"
          >
            <circle cx={1} cy={1} r={0.4} fill="rgba(59,130,246,0.3)" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#fort-kline-grid-dots)" />
      </svg>

      {/* 底部柔和淡出，避免硬切边过于生硬 */}
      <div
        className="absolute inset-x-0 bottom-0 h-16 pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, rgba(6,8,16,0) 0%, rgba(6,8,16,0.85) 100%)",
        }}
      />
    </div>
  );
}
